import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { authService } from '@/services/auth.service';
import { QUERY_KEYS } from '@/utils/constants';

export const useMySessions = () =>
  useQuery({
    queryKey: QUERY_KEYS.SESSIONS.MINE,
    queryFn: authService.listSessions,
  });

export const useRevokeMySession = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => authService.revokeSession(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEYS.SESSIONS.MINE }),
  });
};
